import { render, staticRenderFns } from "./AssetSection.vue?vue&type=template&id=3959cf77&scoped=true&"
import script from "./AssetSection.vue?vue&type=script&lang=js&"
export * from "./AssetSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3959cf77",
  null
  
)

export default component.exports